import { render, staticRenderFns } from "./FontSizeSelector.vue?vue&type=template&id=d8e5b324"
import script from "./FontSizeSelector.vue?vue&type=script&lang=js"
export * from "./FontSizeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports